import { SetPrefixFieldData } from './ChartAxesInterfaces';

export const setPrefix = (
  fieldData: SetPrefixFieldData,
  binName: string,
  chartType: string,
  geoLocation: string = 'world',
) => {
  if (!fieldData) {
    return fieldData;
  }

  let data = JSON.parse(JSON.stringify(fieldData));

  if (data.isCalculatedField) {
    return data;
  }

  switch (data.dataType.toLowerCase()) {
    case 'integer':
    case 'decimal':
      if (['X', 'Y', 'X Axis', 'Y Axis', 'Measure'].includes(binName)) {
        data.agg = 'sum';
      }
      if (binName === 'Location') {
        if (geoLocation === 'world') data.agg = 'name_long';
        else data.agg = 'NAME_1';
      }
      break;

    case 'text':
      if (['X', 'Y', 'X Axis', 'Y Axis', 'Measure'].includes(binName)) {
        data.agg = 'count';
      }
      if (binName === 'Location') {
        if (geoLocation === 'world') data.agg = 'name_long';
        else data.agg = 'NAME_1';
      }
      break;

    case 'date':
    case 'timestamp':
      // cause calendar chart works proper only with date
      if (chartType === 'calendar') {
        // if (binName === "Dimension") {
        if (binName === 'Date') {
          data.timeGrain = 'date';
        } else {
          data.timeGrain = 'year';
          data.agg = 'max';
        }
      }
      //
      else {
        if (data.isCalculatedField && data.isAggregated) {
          data.agg = 'agg';
          break;
        }
        if (['X', 'Y', 'X Axis', 'Y Axis', 'Measure'].includes(binName)) {
          data.timeGrain = 'year';
          data.agg = 'max';
        } else if (binName === 'Dimension') {
          data.timeGrain = 'year';
        } else {
          data.timeGrain = 'year';
        }
      }
      break;
    case 'boolean':
      if (['X', 'Y', 'X Axis', 'Y Axis', 'Measure'].includes(binName)) {
        data.agg = 'count';
      }
      break;
    default:
      break;
  }
  return data;
};
